export default __webpack_public_path__ + "static/Mattress-Firm-efde2bebae113626f6a6c0aa73c5474e.gif";